var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayPdfPage)?_c('div',{staticClass:"pdf-document",attrs:{"id":"pdf-content"}},_vm._l((_vm.pages),function(page){return _c('PDFPage',_vm._b({key:page.pageNumber,attrs:{"page":page}},'PDFPage',{ scale: _vm.scale },false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }